import { Button, ToolbarButton, Tooltip } from '@fluentui/react-components';
import { Play24Regular } from '@fluentui/react-icons';
import { useI18nTranslation } from '@idmc-ms-fabric/common';
import { FC } from 'react';

import { useIDQAPageContext } from '../../../context/business/IDQAPage/IDQAPageContext';
import { useLoginContext } from '../../../context/business/InfaLogin/InfaLoginContext';
import i18nKeys from '../../../i18n/i18nKeys';

type ButtonType = 'toolbar' | 'normal';

const ProfilingButton: FC<{ type: ButtonType; onClick?: () => void; disabled?: boolean; tooltip?: string }> = ({
	type = 'normal',
	onClick,
	disabled,
	tooltip,
}) => {
	const { t } = useI18nTranslation();
	const commonProps = { icon: <Play24Regular />, onClick, disabled };
	const Btn =
		type === 'normal' ? (
			<Button size={'small'} iconPosition={'before'} appearance={'primary'} {...commonProps}>
				{t(i18nKeys.main.runProfiling)}
			</Button>
		) : (
			<ToolbarButton {...commonProps}>{t(i18nKeys.main.runProfiling)}</ToolbarButton>
		);
	return tooltip ? (
		<Tooltip content={tooltip} relationship="label">
			{Btn}
		</Tooltip>
	) : (
		Btn
	);
};

const RunProfilingButton: FC<{ type?: ButtonType }> = ({ type = 'normal' }) => {
	const { state, controller } = useIDQAPageContext();
	const { user_access } = useLoginContext();
	const { t } = useI18nTranslation();

	return user_access === 'READ_ONLY' || controller.isProfilingJobRunning(state) ? (
		<ProfilingButton
			type={type}
			disabled={true}
			tooltip={t(user_access === 'READ_ONLY' ? i18nKeys.main.cannotRunJobMsg : i18nKeys.main.waitForJobToComplete)}
		/>
	) : (
		<ProfilingButton disabled={!state.table} type={type} onClick={() => controller.runProfiling(state)} />
	);
};

export default RunProfilingButton;
